import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { EntityService, myExpariencesService } from "../../../services";
import ExparienceName from "./steps/Name";
import ExparienceLogo from "./steps/ExparienceLogo";
import AppDescription from "./steps/AppDescription";
import Entity from "./steps/Entity";
import Password from "./steps/Password";
import Geoloc from "./steps/Geoloc";
import Price from "./steps/Price";
import Watermark from "./steps/Watermark";
import Tags from "./steps/Tags";
import Users from "./steps/Users";
import EndAndSave from "./steps/EndAndSave";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useViewport } from "../../../helpers";
import { Element, animateScroll as scroll, scroller } from "react-scroll";
import { CircularProgress, Container, Paper, Button } from "@mui/material";
import { Typography } from "@mui/material";
import ProgressLine from "./steps/ProgressLine";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import TimeAvailability from './steps/TimeAvailibity';
import { closeBackdrop } from "../../../reducers/expariences/expariencesSlice";

const PREFIX = "CreateExparienceManager";

const classes = {
  root: `${PREFIX}-root`,
  rootTitle: `${PREFIX}-rootTitle`,
  fixedTopContainer: `${PREFIX}-fixedTopContainer`,
  clickOnTitle: `${PREFIX}-clickOnTitle`,
  checkIcon: `${PREFIX}-checkIcon`,
  marginIcon: `${PREFIX}-marginIcon`,
  returnButton: `${PREFIX}-returnButton`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.root}`]: {
    width: "100%",
    maxWidth: "650px",
    padding: "0 1rem",
  },

  [`& .${classes.rootTitle}`]: {
    textAlign: "center",
    marginTop: "0.5rem",
    color: "#FFFFFFB3",
    paddingRight: "1.5rem",
  },

  [`& .${classes.fixedTopContainer}`]: {
    position: "fixed",
  },

  [`& .${classes.clickOnTitle}`]: {
    cursor: "pointer",
    marginBottom: "0.5rem",
  },

  [`& .${classes.checkIcon}`]: {
    position: "absolute",
    transform: "translate(10px, -4px)",
  },

  [`& .${classes.marginIcon}`]: {
    marginRight: "0.5rem",
  },

  [`& .${classes.returnButton}`]: {
    marginBottom: "1rem",
  },
}));

const CreateExparienceManager = (props) => {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedLink, setSelectedLink] = useState(0);

  const handleNextStep = (step) => {
    setSelectedLink(step);
    if (step > currentStep) {
      setCurrentStep(currentStep + 1);
    }
  };
  const handleChangeField = (key, value) => {
    if (key === "multiple")
      setNewExparience({
        ...newExparience,
        packageId: value.packageId,
        offeringId: value.offeringId,
      });
    else setNewExparience({ ...newExparience, [key]: value });
  };

  const [newExparience, setNewExparience] = useState({
    name: "",
    displayName: "",
    logo: "",
    description: {
      initial: "",
      translations: [],
    },
    descriptionApp: "",
    entityId: "",
    entityName: "",
    entity: null,
    securedByPassword: null,
    password: "",
    securedByPosition: null,
    positions: [],
    offeringId: "",
    packageId: "",
    clientLogo: "",
    hashtag: "",
    tags: [],
    userDetails: [],
    users: [],
  });
  const [files, setFiles] = useState({});
  const [isValid, setIsValid] = useState(true);
  const [fetchedEntities, setFetchedEntities] = useState(null);
  const [fetchedUsers, setFetchedUsers] = useState(null);
  const history = useNavigate();
  const headerHidden = useSelector((state) => state.myExpariences.headerHidden);
  const [saving, setSaving] = useState(false);
  const { width } = useViewport();
  const [offerings, setOfferings] = useState(null);

  useEffect(() => {
    handleScrollTo(currentStep);
  }, [currentStep]);

  const handleScrollTo = (index, offset = 0) => {
    scroller.scrollTo(`myScrollToElement${index}`, {
      duration: 300,
      smooth: true,
      offset,
    });
    if (currentStep >= index) setSelectedLink(index);
  };

  const getUniqueFiles = (files) => {
    const uniqueFiles = files.length > 0 ? [files[0]] : [];
    files.forEach((file) => {
      let exist = false;
      uniqueFiles.forEach((uniq) => {
        if (uniq.name === file.name) exist = true;
      });
      if (!exist) {
        uniqueFiles.push(file);
      }
    });
    return uniqueFiles;
  };

  const handleSaveAndAction = (option) => {
    setSaving(true);
    let tmpExparience = { ...newExparience };
    const tmpTags = tmpExparience.tags.map((item) => item.label);
    delete tmpExparience.entityName;
    tmpExparience.tags = tmpTags;
    let tmpFiles = [];
    const keys = Object.keys(files);
    if (keys.length > 0) {
      keys.forEach((fileKey) => {
        tmpFiles.push(files[fileKey][0]);
      });
    }
    tmpFiles = getUniqueFiles(tmpFiles);

    myExpariencesService.createNewExparience(tmpExparience, tmpFiles).then(
      (res) => {
        enqueueSnackbar(t("toasts.exparienceCreatedSuccess"), {
          variant: "success",
        });
        dispatch(closeBackdrop());
        if (option === "configure")
          history(`/myExpariences/${res.id}/configurator`);
        else history("/myExpariences");
        setSaving(false);
      },
      (error) => {
        enqueueSnackbar(t("toasts.exparienceCreatedError"), {
          variant: "error",
        });
        setSaving(false);
      }
    );
  };

  useEffect(() => {
    if (!fetchedEntities) {
      EntityService.getEntities("sphere").then((result) => {
        setFetchedEntities(result.data);
      });
    }
    if (!offerings) {
      myExpariencesService.getOfferings().then(
        (res) => {
          setOfferings(res);
        },
        (error) => {
          enqueueSnackbar(t("toasts.getOfferingsError"), { variant: "error" });
        }
      );
    }
  }, []);

  const nodesForm = [
    {
      name: t("exparienceCreateForm.nameMenu"),
      node: (
        <Element name="myScrollToElement0" key="createExparienceName">
          <ExparienceName
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            exparience={newExparience}
            isAdmin={props.isAdmin}
            setIsValid={setIsValid}
          />
        </Element>
      ),
    },
    {
      name: t("exparienceCreateForm.exparienceLogoMenu"),
      node: (
        <Element name="myScrollToElement1" key="createExparienceLogo">
          <ExparienceLogo
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            exparience={newExparience}
            files={files}
            setFiles={setFiles}
          />
        </Element>
      ),
    },
    {
      name: t("exparienceCreateForm.descriptionMenu"),
      node: (
        <Element name="myScrollToElement2" key="createExparienceDescriptionApp">
          <AppDescription
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            exparience={newExparience}
            setExparience={setNewExparience}
            setIsValid={setIsValid}
          />
        </Element>
      ),
    },
    {
      name: t("exparienceCreateForm.sphereMenu"),
      node: (
        <Element name="myScrollToElement3" key="createExparienceEntity">
          <Entity
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            setNewExparience={setNewExparience}
            exparience={newExparience}
            fetchedEntities={fetchedEntities}
            setIsValid={setIsValid}
          />
        </Element>
      ),
    },
    // {name: t('exparienceCreateForm.availability'),node:
    // <Element
    //   name="myScrollToElement4"
    //   key="createExparienceAvailability"
    // >
    //   <TimeAvailability
    //     currentStep={currentStep}
    //     handleNextStep={handleNextStep}
    //     handleChangeField={handleChangeField}
    //     exparience={newExparience}
    //     setIsValid={setIsValid}
    //   />
    // </Element>},
    {
      name: t("exparienceCreateForm.passwordMenu"),
      node: (
        <Element name="myScrollToElement4" key="createExpariencePassword">
          <Password
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            exparience={newExparience}
            setIsValid={setIsValid}
          />
        </Element>
      ),
    },
    {
      name: t("exparienceCreateForm.geolocMenu"),
      node: (
        <Element name="myScrollToElement5" key="createExparienceGeoloc">
          <Geoloc
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            exparience={newExparience}
            setIsValid={setIsValid}
          />
        </Element>
      ),
    },
    {
      name: t("exparienceCreateForm.paymentMenu"),
      node: (
        <Element name="myScrollToElement6" key="createExpariencePrice">
          <Price
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            exparience={newExparience}
            setIsValid={setIsValid}
            offerings={offerings}
          />
        </Element>
      ),
    },
    {
      name: t("exparienceCreateForm.watermarkMenu"),
      node: (
        <Element name="myScrollToElement7" key="createExparienceWatermark">
          <Watermark
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            exparience={newExparience}
            files={files}
            setFiles={setFiles}
          />
        </Element>
      ),
    },
    {
      name: t("exparienceCreateForm.tagsMenu"),
      node: (
        <Element name="myScrollToElement8" key="createExparienceTags">
          <Tags
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            exparience={newExparience}
          />
        </Element>
      ),
    },
    {
      name: t("exparienceCreateForm.authorizationsMenu"),
      node: (
        <Element name="myScrollToElement9" key="createExparienceUsers">
          <Users
            currentStep={currentStep}
            handleNextStep={handleNextStep}
            handleChangeField={handleChangeField}
            exparience={newExparience}
            fetchedUsers={fetchedUsers}
          />
        </Element>
      ),
    },
    {
      name: t("exparienceCreateForm.saveMenu"),
      node: (
        <Element name="myScrollToElement10" key="createExparienceEndAndSave">
          <EndAndSave
            currentStep={currentStep}
            exparience={newExparience}
            isValid={isValid}
            files={files}
            handleSaveAndAction={handleSaveAndAction}
          />
        </Element>
      ),
    },
  ];

  const getValueFromObject = (index) => {
    if (currentStep >= index) {
      switch (index) {
        case 0:
          return <span>{newExparience.displayName}</span>;
        case 1:
          return newExparience.logo && currentStep > 1 ? (
            <Root>
              <CheckIcon className={classes.checkIcon} color="primary" />
            </Root>
          ) : null;
        case 2:
          return newExparience.descriptionApp ? (
            <span>{newExparience.descriptionApp}</span>
          ) : currentStep > 2 ? (
            <Root>
              <CheckIcon className={classes.checkIcon} color="primary" />
            </Root>
          ) : null;
        case 3:
          return newExparience.entityName ? (
            <span>{newExparience.entityName}</span>
          ) : currentStep > 3 ? (
            <Root>
              <CheckIcon className={classes.checkIcon} color="primary" />
            </Root>
          ) : null;
        // case 4:
        // return ((newExparience.startDate && newExparience.endDate) || (newExparience.startDate && !newExparience.endDate) || (!newExparience.startDate && !newExparience.endDate) && currentStep > 4) ? <CheckIcon className={classes.checkIcon} color="primary" /> : null
        case 4:
          return newExparience.securedByPassword ? (
            <span>{newExparience.password}</span>
          ) : currentStep > 4 ? (
            <Root>
              <CheckIcon className={classes.checkIcon} color="primary" />
            </Root>
          ) : null;
        case 5:
          return newExparience.securedByPosition || currentStep > 5 ? (
            <Root>
              <CheckIcon className={classes.checkIcon} color="primary" />
            </Root>
          ) : null;
        case 6:
          return newExparience.price || currentStep > 6 ? (
            <span>{newExparience.price}</span>
          ) : null;
        case 7:
          return currentStep > 7 ? (
            <Root>
              <CheckIcon className={classes.checkIcon} color="primary" />
            </Root>
          ) : null;
        case 8:
          return currentStep > 8 ? (
            <Root>
              <CheckIcon className={classes.checkIcon} color="primary" />
            </Root>
          ) : null;
        case 9:
          return currentStep > 9 ? (
            <Root>
              <CheckIcon className={classes.checkIcon} color="primary" />
            </Root>
          ) : null;
        default:
          return null;
      }
    }
  };

  if (saving) {
    return (
      <Container>
        <div className="loading-container">
          <CircularProgress size={50} />
          <Typography>{t("loaders.saving")}</Typography>
        </div>
      </Container>
    );
  } else {
    return (
      <Root>
        <Paper
          elevation={6}
          className={classes.fixedTopContainer}
          style={{
            height: width <= 975 ? "56px" : "auto",
            top:
              width <= 975 && headerHidden
                ? "0"
                : width <= 975 && !headerHidden
                ? "56px"
                : "60px",
            width: "100%",
            padding: "0 1rem",
            zIndex: "99",
            backgroundColor: "#424242",
            marginTop: width > 975 ? "1rem" : 0,
            left: width > 975 ? "1rem" : "inherit",
            maxWidth: width > 975 ? "22vw" : "100%",
          }}
        >
          <Typography variant="h5" className={classes.rootTitle}>
            {t("exparienceCreateForm.createMyExparience")}
          </Typography>
          <ProgressLine step={currentStep} />
          {width > 975 &&
            nodesForm.map((node, index) => {
              return (
                <div
                  key={`node-${node.name}-${index}`}
                  className={classes.clickOnTitle}
                >
                  <Typography
                    variant="body2"
                    onClick={(e) =>
                      currentStep >= index
                        ? handleScrollTo(index, -80)
                        : undefined
                    }
                    style={{
                      textDecoration:
                        selectedLink === index ? "underline" : "none",
                      color:
                        selectedLink === index && theme.palette.primary.main,
                      fontWeight: selectedLink === index && "bold",
                      opacity: !(currentStep >= index) ? "0.5" : "1",
                      display: "flex",
                    }}
                  >
                    {index + 1} - {node.name} - {getValueFromObject(index)}
                  </Typography>
                </div>
              );
            })}
        </Paper>
        <div
          className={classes.root}
          style={{
            margin: "1rem auto",
            left: width > 975 ? "22vw" : "",
          }}
        >
          <Button
            variant="contained"
            onClick={(e) => history("/myExpariences")}
            color="primary"
            className={classes.returnButton}
          >
            <KeyboardReturnIcon className={classes.marginIcon} />
            {t("topMenu.myExpariences")}
          </Button>
          {nodesForm.map((node, subIndex) => (
            <div
              style={{
                backgroundColor: selectedLink === subIndex && "#484848",
                borderRadius: "12px",
              }}
              key={`{node.key}-${subIndex}`}
            >
              {node.node}
            </div>
          ))}
        </div>
      </Root>
    );
  }
};

export default CreateExparienceManager;
